import { z } from 'zod';

export const InputSchema = z.object({
    customerId: z.number(),
    paymentProvidersType: z.string(),
});

export type InputSchemaType = z.infer<typeof InputSchema>;

const RecordStringNumberOrNullUndefined = z.record(z.number()).nullable().optional();

const counters = z.object({
    bets: RecordStringNumberOrNullUndefined,
    'casino-bets': RecordStringNumberOrNullUndefined,
    'casino-operator-profits': RecordStringNumberOrNullUndefined,
    'casino-operator-turnover': RecordStringNumberOrNullUndefined,
    'casino-profits': RecordStringNumberOrNullUndefined,
    'casino-turnover': RecordStringNumberOrNullUndefined,
    'livecasino-bets': RecordStringNumberOrNullUndefined,
    'livecasino-operator-profit': RecordStringNumberOrNullUndefined,
    'livecasino-operator-turnover': RecordStringNumberOrNullUndefined,
    'livecasino-profit': RecordStringNumberOrNullUndefined,
    'livecasino-turnover': RecordStringNumberOrNullUndefined,
    'operator-profits': RecordStringNumberOrNullUndefined,
    profits: RecordStringNumberOrNullUndefined,
    turnover: RecordStringNumberOrNullUndefined,
    'virtualsports-bets': RecordStringNumberOrNullUndefined,
    'virtualsports-operator-profits': RecordStringNumberOrNullUndefined,
    'virtualsports-operator-turnover': RecordStringNumberOrNullUndefined,
    'virtualsports-profits': RecordStringNumberOrNullUndefined,
    'virtualsports-turnover': RecordStringNumberOrNullUndefined,
});

export const SuccessResponseSchema = counters;

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export const ErrorResponseSchema = z.object({
    errors: z.array(
        z.object({
            resource: z.string().optional().nullable(),
            field: z.string().optional().nullable(),
            code: z.string().optional().nullable(),
            debugDetails: z.string().optional().nullable(),
        })
    ),
});

type ErrorResponseType = z.infer<typeof ErrorResponseSchema>;

export type ResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | { responseStatus: 'error'; data: ErrorResponseType };
